import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgExtendedCancel = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 30,
	height: 30,
	viewBox: "0 0 30 30",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 15,
			cy: 15,
			r: 11.875,
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.725 20.9375L15 16.6625L19.275 20.9375L20.9375 19.275L16.6625 15L20.9375 10.725L19.275 9.0625L15 13.3375L10.725 9.0625L9.0625 10.725L13.3375 15L9.0625 19.275L10.725 20.9375ZM15 26.875C13.3573 26.875 11.8135 26.5633 10.3688 25.9398C8.92396 25.3164 7.66719 24.4703 6.59844 23.4016C5.52969 22.3328 4.68359 21.076 4.06016 19.6313C3.43672 18.1865 3.125 16.6427 3.125 15C3.125 13.3573 3.43672 11.8135 4.06016 10.3688C4.68359 8.92396 5.52969 7.66719 6.59844 6.59844C7.66719 5.52969 8.92396 4.68359 10.3688 4.06016C11.8135 3.43672 13.3573 3.125 15 3.125C16.6427 3.125 18.1865 3.43672 19.6313 4.06016C21.076 4.68359 22.3328 5.52969 23.4016 6.59844C24.4703 7.66719 25.3164 8.92396 25.9398 10.3688C26.5633 11.8135 26.875 13.3573 26.875 15C26.875 16.6427 26.5633 18.1865 25.9398 19.6313C25.3164 21.076 24.4703 22.3328 23.4016 23.4016C22.3328 24.4703 21.076 25.3164 19.6313 25.9398C18.1865 26.5633 16.6427 26.875 15 26.875Z",
			fill: "url(#paint0_linear_4012_59736)"
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint0_linear_4012_59736",
			x1: 3.00003,
			y1: 27.1875,
			x2: 31.0097,
			y2: 8.98124,
			gradientUnits: "userSpaceOnUse",
			children: [
				/* @__PURE__ */ _jsx("stop", { stopColor: "#142F95" }),
				/* @__PURE__ */ _jsx("stop", {
					offset: .5,
					stopColor: "#2563EB"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#CACBFF"
				})
			]
		}) })
	]
});
export default SvgExtendedCancel;
